import { render } from "./fbx-radio.vue?vue&type=template&id=5fc73f16&scoped=true&ts=true"
import script from "./fbx-radio.vue?vue&type=script&lang=ts"
export * from "./fbx-radio.vue?vue&type=script&lang=ts"

import "./fbx-radio.vue?vue&type=style&index=0&id=5fc73f16&scoped=true&lang=scss"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc73f16"]])

export default __exports__